
import { TEAM_LIST_VERTICAL_ID, VERTICAL_LIST } from "modules/poc-dashboard/graphql/organizationQuery.gql";
import EditEmployeeDetailView from "../../components/organization/editEmployeeDetailView";
import React from "react";
import { compose } from "modules/core";
import { withApollo } from '@apollo/client/react/hoc';
import { getOrgID, withEditPocEmpolee } from "./organizationOperations";
import { Capitalize, getIntFromString } from "modules/look";
const EditEmployeeDetailContainer = (props) => {
    // eslint-disable-next-line no-unused-vars
    const { client, me, updateEmployee, onCancel, edit_details, onSuccess, orgToFetchData } = props
    const [verticals, setVerticals] = React.useState()
    const [teams, setTeams] = React.useState([])
    React.useEffect(() => {
        if (me && (orgToFetchData?.id || getOrgID(props))) {
            verticalList()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [me, orgToFetchData])
    const verticalList = async () => {
        const { data } = await client.query({
            query: VERTICAL_LIST,
            fetchPolicy: 'network-only',
            variables: {
                id: getOrgID(props) || orgToFetchData?.id
            }
        });
        if (data?.organizationById?.verticalSet?.edges?.length) {
            setVerticals(data?.organizationById?.verticalSet?.edges?.map(({ node }) => node))
        }
    }
    const getTeamlist = async (id) => {
        const { data } = await client.query({
            query: TEAM_LIST_VERTICAL_ID,
            variables: {
                vertical: getIntFromString(id),
                id: getOrgID(props) || orgToFetchData?.id
            },
            fetchPolicy: 'network-only'
        });
        if (data?.organizationById?.verticalSet?.edges[0]?.node?.teamSet?.edges?.length) {
            setTeams(data?.organizationById?.verticalSet?.edges[0]?.node?.teamSet?.edges?.map(({ node }) => node))
        }
    }
    const updateUserDetail = async (value) => {
        if (value) {
            let update_data = {
                id: getIntFromString(edit_details?.id),
                fname: Capitalize(value?.firstName),
                lname: Capitalize(value?.lastName),
                email: value?.email,
            }
            let response = await updateEmployee({ ...update_data })
            if (response) {
                let edited_details = { ...edit_details, firstName: Capitalize(value?.firstName), lastName: Capitalize(value?.lastName), email: value?.email }
                onSuccess(edited_details)
            }
        }
    }
    return (
        <>
            <EditEmployeeDetailView {...props}
                verticals={verticals} teams={teams}
                getTeamlist={(key) => getTeamlist(key)}
                updateuser={(value) => updateUserDetail(value)} />
        </>
    )
}

export default compose(withApollo, withEditPocEmpolee)(EditEmployeeDetailContainer);